import { useMemo } from "react";
import { currencyLabels } from "@/utils/ranges.util";
import type { CompanyEntryRangeDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryRangeDto";

import Badge from "@/components/atoms/Badge";

type Props = CompanyEntryRangeDto;

const getEarningBadgeColor = (from?: number | null) => {
  if (from === null) return "natural";

  if (from! >= 0) {
    return "success";
  } else {
    return "error";
  }
};

const EarningRangeBadge = ({ from, to }: Props) => {
  if (!from && !to) return null;

  const label = useMemo(() => currencyLabels(from, to), [from, to]);
  const color = useMemo(() => getEarningBadgeColor(from), [from]);
  return <Badge color={color} label={label} size={"sm"} />;
};

export default EarningRangeBadge;
